import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: {
    accessibilityTop: number | null;
} = {
    accessibilityTop: null
};

const accessibility = createSlice({
    name: 'accessibility',
    initialState: initialState,
    reducers: {
        setAccessibilityTop: (state, action: PayloadAction<number>) => {
            state.accessibilityTop = action.payload;
        }
    }
});
export const { setAccessibilityTop } = accessibility.actions;
export default accessibility;
